import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_1264c752 from 'nuxt_plugin_plugin_1264c752' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_51c2d397 from 'nuxt_plugin_bootstrapvue_51c2d397' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_202bad10 from 'nuxt_plugin_cookieuniversalnuxt_202bad10' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginrouting_478a725e from 'nuxt_plugin_pluginrouting_478a725e' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_79e4c5d1 from 'nuxt_plugin_pluginmain_79e4c5d1' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_7389dd68 from 'nuxt_plugin_axios_7389dd68' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_48a25461 from 'nuxt_plugin_vuesocialsharingplugin_48a25461' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_toast_3fba2a17 from 'nuxt_plugin_toast_3fba2a17' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_nuxtsvgsprite_78781686 from 'nuxt_plugin_nuxtsvgsprite_78781686' // Source: ./nuxt-svg-sprite.js (mode: 'all')
import nuxt_plugin_moment_0c5d6130 from 'nuxt_plugin_moment_0c5d6130' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_smoothscrollpolyfill_b8ee2e28 from 'nuxt_plugin_smoothscrollpolyfill_b8ee2e28' // Source: ../plugins/smoothscroll-polyfill.js (mode: 'client')
import nuxt_plugin_vuealert_67c5e410 from 'nuxt_plugin_vuealert_67c5e410' // Source: ../plugins/vue-alert.js (mode: 'client')
import nuxt_plugin_vuepassword_95fa7d02 from 'nuxt_plugin_vuepassword_95fa7d02' // Source: ../plugins/vue-password.js (mode: 'client')
import nuxt_plugin_vuemask_08817de4 from 'nuxt_plugin_vuemask_08817de4' // Source: ../plugins/vue-mask.js (mode: 'client')
import nuxt_plugin_vform_a6ff8a1a from 'nuxt_plugin_vform_a6ff8a1a' // Source: ../plugins/vform.js (mode: 'client')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_echo_7481157c from 'nuxt_plugin_echo_7481157c' // Source: ../plugins/echo.js (mode: 'client')
import nuxt_plugin_embed_21ed95f4 from 'nuxt_plugin_embed_21ed95f4' // Source: ../plugins/embed.js (mode: 'client')
import nuxt_plugin_aos_78651e70 from 'nuxt_plugin_aos_78651e70' // Source: ../plugins/aos.js (mode: 'client')
import nuxt_plugin_nuxtclientinit_3893cbb9 from 'nuxt_plugin_nuxtclientinit_3893cbb9' // Source: ../plugins/nuxt-client-init.js (mode: 'client')
import nuxt_plugin_toastnotification_318f37d0 from 'nuxt_plugin_toastnotification_318f37d0' // Source: ../plugins/toast-notification.js (mode: 'client')
import nuxt_plugin_vueawesomeswiper_0f4ed586 from 'nuxt_plugin_vueawesomeswiper_0f4ed586' // Source: ../plugins/vue-awesome-swiper (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: function() {
    return {
      title: 'Franchise123',
      titleTemplate: '%s | Franchise123',
      meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { hid: 'description', name: 'description', content: 'Franchise123 Description' },
      {
        hid: 'og:title',
        property: 'og:title',
        content: 'Franchise123',
        template: function (title) {
          return `${title}`;
        } },

      {
        hid: 'og:url',
        property: 'og:url',
        content: 'www.franchise123.com',
        template: function (url) {
          return `${url}`;
        } },

      { hid: 'og:image:type', property: 'og:image:type', content: 'image/jpeg' }
      // { hid: 'og:image', property: 'og:image', href: 'http://localhost:3000/og-image.jpg' },
      ],
      link: [
      { rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' },
      { rel: 'og:image', property: 'og:image', href: '/og-image.jpg' }],

      script: [
      {
        src: '//js.hs-scripts.com/6241267.js',
        defer: true,
        async: true }],

      htmlAttrs: {
        prefix: 'og: http://ogp.me/ns#',
        lang: 'en' } };
  },

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_1264c752 === 'function') {
    await nuxt_plugin_plugin_1264c752(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_51c2d397 === 'function') {
    await nuxt_plugin_bootstrapvue_51c2d397(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_202bad10 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_202bad10(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_478a725e === 'function') {
    await nuxt_plugin_pluginrouting_478a725e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_79e4c5d1 === 'function') {
    await nuxt_plugin_pluginmain_79e4c5d1(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_7389dd68 === 'function') {
    await nuxt_plugin_axios_7389dd68(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_48a25461 === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_48a25461(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_3fba2a17 === 'function') {
    await nuxt_plugin_toast_3fba2a17(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsvgsprite_78781686 === 'function') {
    await nuxt_plugin_nuxtsvgsprite_78781686(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_0c5d6130 === 'function') {
    await nuxt_plugin_moment_0c5d6130(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_smoothscrollpolyfill_b8ee2e28 === 'function') {
    await nuxt_plugin_smoothscrollpolyfill_b8ee2e28(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuealert_67c5e410 === 'function') {
    await nuxt_plugin_vuealert_67c5e410(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuepassword_95fa7d02 === 'function') {
    await nuxt_plugin_vuepassword_95fa7d02(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuemask_08817de4 === 'function') {
    await nuxt_plugin_vuemask_08817de4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vform_a6ff8a1a === 'function') {
    await nuxt_plugin_vform_a6ff8a1a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_echo_7481157c === 'function') {
    await nuxt_plugin_echo_7481157c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_embed_21ed95f4 === 'function') {
    await nuxt_plugin_embed_21ed95f4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_aos_78651e70 === 'function') {
    await nuxt_plugin_aos_78651e70(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtclientinit_3893cbb9 === 'function') {
    await nuxt_plugin_nuxtclientinit_3893cbb9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toastnotification_318f37d0 === 'function') {
    await nuxt_plugin_toastnotification_318f37d0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueawesomeswiper_0f4ed586 === 'function') {
    await nuxt_plugin_vueawesomeswiper_0f4ed586(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    const { route } = router.resolve(app.context.route.fullPath)
    // Ignore 404s rather than blindly replacing URL
    if (!route.matched.length && process.client) {
      return resolve()
    }
    router.replace(route, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
